import styled from 'styled-components';

const InfoContainer = styled.div`
  margin-left: 16px;
  flex: 0 1 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
`;

export default InfoContainer;
